import type { LucideIcon } from "lucide-react";
import { cn } from "@nexus/ui";

interface TableEmptyStateProps {
  icon: LucideIcon;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  /** "solid" (People/Roles tables) or "dashed" (Invites table). */
  variant?: "solid" | "dashed";
}

/**
 * "No rows match your filters" placeholder. Single source for the
 * near-identical empty states previously duplicated across the People,
 * Roles, and Invites tables.
 */
export function TableEmptyState({ icon: Icon, title, subtitle, variant = "solid" }: TableEmptyStateProps) {
  return (
    <div
      className={cn(
        "flex min-h-full flex-col items-center justify-center gap-2 border-t py-16 text-center",
        variant === "dashed" ? "border-dashed border-border bg-card/30" : "border-border bg-card",
      )}
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted">
        <Icon className="h-5 w-5 text-muted-foreground" />
      </div>
      <p className="text-sm font-medium">{title}</p>
      <p className="text-xs text-muted-foreground">{subtitle}</p>
    </div>
  );
}
